import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { type PayloadAction } from "@reduxjs/toolkit";
import { quickOrderActions } from "./slice";
import {
  submitQuickOrder,
  fetchQuickOrderApi,
  updateQuickOrderApi,
} from "../../services/quickOrder/quickOrder.api";
import { type QuickOrderPayload } from "../../types/quickOrder";
import { withLoader } from "../loader/saga";

// Worker Saga for POST
export function* submitQuickOrderSaga(
  action: PayloadAction<QuickOrderPayload>
): SagaIterator {
  try {
    const response = yield* withLoader(function* () {
      return yield call(submitQuickOrder, action.payload);
    });
    yield put(quickOrderActions.submitQuickOrderSuccess(response));
  } catch (error: any) {
    yield put(
      quickOrderActions.submitQuickOrderFailure(
        "Something went wrong.Please try again."
      )
    );
  }
}

export function* fetchQuickOrderDataSaga(action: PayloadAction<number>) {
  try {
    const response = yield* withLoader(function* () {
      return yield call(fetchQuickOrderApi, action.payload);
    });

    yield put(quickOrderActions.fetchQuickOrderDataSuccess(response)); // dispatch success action
  } catch (error: any) {
    yield put(quickOrderActions.fetchQuickOrderDataFailure(error.message)); // dispatch failure action
  }
}

export type UpdateOrderPayload = {
  orderId: number;
  data: QuickOrderPayload;
};

export function* updateQuickOrderSaga(
  action: PayloadAction<UpdateOrderPayload>
) {
  try {
    const response = yield* withLoader(function* () {
      return yield call(
        updateQuickOrderApi,
        action.payload.orderId,
        action.payload.data
      );
    });

    yield put(quickOrderActions.updateQuickOrderSuccess(response));
  } catch (error: any) {
    yield put(
      quickOrderActions.updateQuickOrderFailure(
        error.message || "Update failed"
      )
    );
  }
}

// Watcher Saga: Watches for actions dispatched to the store, starts worker saga
function* watchFetchQuickOrderData() {
  yield takeLatest(
    quickOrderActions.fetchQuickOrderDataStart.type,
    fetchQuickOrderDataSaga
  );
}

function* watchUpdateQuickOrderSaga() {
  yield takeLatest(
    quickOrderActions.updateQuickOrderStart.type,
    updateQuickOrderSaga
  );
}

function* quickOrderWatcherSaga() {
  yield takeLatest(
    quickOrderActions.submitQuickOrderStart.type,
    submitQuickOrderSaga
  );
}
export {
  quickOrderWatcherSaga,
  watchFetchQuickOrderData,
  watchUpdateQuickOrderSaga,
};
